
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42.952","height":"31.082"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7085","d":"M17.32 20.115a44.239 44.239 0 01.844-5.428c.664-2.9 1.563-4.817 2.543-5.48v10.907zm4.924-10.907c.98.662 1.88 2.578 2.544 5.48a44.21 44.21 0 01.844 5.428h-3.387zm4.932 10.907a45.6 45.6 0 00-.886-5.754c-1.052-4.611-2.672-6.949-4.814-6.949s-3.762 2.338-4.814 6.949a45.521 45.521 0 00-.886 5.754H7.815a42.025 42.025 0 012.533-9.094c2.672-6.39 6.416-9.63 11.128-9.63s8.457 3.24 11.129 9.63a42.022 42.022 0 012.533 9.094zm-22.447 0c1.388-8.172 4.239-13.8 8.481-16.73.179-.124.357-.238.535-.348a21.275 21.275 0 00-4.829 7.42 43.112 43.112 0 00-2.66 9.658zm31.965 0a43.087 43.087 0 00-2.66-9.658 21.268 21.268 0 00-4.829-7.42c.178.11.356.224.535.348 4.242 2.932 7.094 8.558 8.482 16.73zm-9.761 10.466H16.018A17.366 17.366 0 01.851 21.652H42.1a17.367 17.367 0 01-15.168 8.929z","fill":"none"}})])
          )
        }
      }
    